import { useState } from "react";

import {
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  Typography,
  TableFooter,
  TablePagination,
} from "@mui/material";
import Table from "@mui/material/Table";
import PropTypes from "prop-types";
import HistoryRow from "./HistoryRow";

const HistoryTable = ({ results, wins, losses, onDelete }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handlePageChange = (event, newPage) => setPage(newPage);
  const handleRowPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <section>
      {results.length > 0 ? (
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center">Deck</TableCell>
                <TableCell align="center">Opponent</TableCell>
                <TableCell align="center">Order</TableCell>
                <TableCell align="center">Result</TableCell>
                <TableCell align="left">Notes</TableCell>
                <TableCell
                  align="center"
                  sx={{ backgroundColor: "black", color: "white" }}
                >
                  {wins} W / {losses} L
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((game) => (
                  <HistoryRow key={game.id} game={game} onDelete={onDelete} />
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={results.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowPerPageChange}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      ) : (
        <Card sx={{ padding: 2 }}>
          <Typography variant="h6">No Match Results</Typography>
          <Typography variant="subtitle1">
            {onDelete
              ? 'Record a game and they will be logged here.'
              : 'Please change your filters or record a game'
            }
          </Typography>
        </Card>
      )}
    </section>
  );
};

HistoryTable.propTypes = {
  results: PropTypes.array,
  wins: PropTypes.number,
  losses: PropTypes.number,
  onDelete: PropTypes.func,
};

export default HistoryTable;
